<div class="animated fadeIn rounded">
  <div class="card">
    <div class="card-header">
      <i class="fa fa-ban"></i> Anulación de Pagos
    </div>
    <div class="card-body">
      <pos-table tableFormId="productTableId" [headers]="getVoidPaymentsTable()" [filters]="getVoidPaymentsFilter()"
        [data]="payments" [itemsPerPage]="10" (dataChange)="getVoidPayments($event)" [badgeDangerValues]="'RETURNED'">
      </pos-table>
    </div>
  </div>
</div>